const windows = [
  { label: 'Window 1', result: '+12.4%', color: '#22c55e' },
  { label: 'Window 2', result: '+8.1%', color: '#22c55e' },
  { label: 'Window 3', result: '+2.3%', color: '#f59e0b' },
  { label: 'Window 4', result: '+9.7%', color: '#22c55e' },
];

export default function WalkForwardMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Walk-Forward Analysis</div>
      <div className="platform-mock-body">
        {windows.map((w) => (
          <div className="mock-wfa-bar" key={w.label}>
            <span className="mock-wfa-label">{w.label}</span>
            <div className="mock-wfa-segments">
              <div className="mock-wfa-train" style={{ width: '70%' }} />
              <div className="mock-wfa-test" style={{ width: '30%' }} />
            </div>
            <span className="mock-wfa-result" style={{ color: w.color }}>{w.result}</span>
          </div>
        ))}
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginTop: '0.75rem', fontSize: '0.625rem', color: '#6b7280' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <span style={{ width: 10, height: 10, background: '#3b82f6', opacity: 0.35, borderRadius: 2, display: 'inline-block' }} /> Train (optimise)
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
            <span style={{ width: 10, height: 10, background: '#22c55e', opacity: 0.5, borderRadius: 2, display: 'inline-block' }} /> Test (unseen data)
          </span>
        </div>
        <div className="mock-verdict" style={{ marginTop: '0.75rem' }}>
          <span className="mock-verdict-icon">P</span>
          <span className="mock-verdict-text">Validation Passed &mdash; consistent out-of-sample performance</span>
        </div>
      </div>
      <div className="platform-mock-caption">Walk-forward analysis tests a strategy on data it has never seen, window by window.</div>
    </div>
  );
}
